import { useEffect, useState } from "react";

// Reports and copyright cases waiting for a moderator, checked on each page: asked once, however many
// parts of the menu show the number.
let asked = { path: null, answer: null };
export function useModerationCount(admin, path) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!admin) { setCount(0); return undefined; }
    let current = true;
    if (asked.path !== path) asked = { path, answer: fetch("/api/admin/moderation?count=1").then((response) => response.json().catch(() => null).then((data) => response.ok ? data : null)).catch(() => null) };
    asked.answer.then((data) => { if (current && data) setCount(data.count); });
    return () => { current = false; };
  }, [admin, path]);
  return count;
}
